export default "__VITE_ASSET__6181fe67__"